import { LoadableLazy } from '@confluence/loadable';

export const EndUserRequestUpgradeModalEntrypoint = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EndUserRequestUpgradeModal" */ './EndUserRequestUpgradeModal.tsx'
			)
		).EndUserRequestUpgradeModal,
});
